module.exports = "<div class=\"holding-dashboard-hero-actions__button holding-dashboard-hero-actions__button--back\" ng-if=isActive ng-click=back()> <svg class=holding-dashboard-hero-actions__button-icon width=16 height=16> <use xlink:href=#left-arrow-icon></use> </svg> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/flow/directives/flow-back/flow-back.html
// module id = 516
// module chunks = 0